export enum PostReportMode {
  GRID = 'GRID',
  TABLE = 'TABLE'
}
